<div
  [ngClass]="useLargeRoundedCorners ? 'tw-rounded-t-3xl' : 'tw-rounded-t-xl'"
  class="tw-bg-color-surface-card"
  style="padding-top: env(safe-area-inset-top, 0px)"
>
  <div
    class="tw-relative tw-flex tw-h-[70px] tw-items-center tw-justify-between tw-px-8 xs:tw-px-5"
  >
    <app-help-tooltip
      [ngClass]="{ 'tw-hidden': !enableTooltip }"
      [showHelpTooltip]="tooltip.showHelpTooltip"
      [tooltipInfo]="tooltipInfo"
      [pointer]="'modal-header'"
      (onTooltipClose)="tooltip.close()"
    ></app-help-tooltip>

    @if (showMobileLayout) {
      <div class="tw-relative tw-w-full tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-flex-none tw-min-w-[2.5rem] tw-items-center">
          <ng-container *ngTemplateOutlet="backButton"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="titleSection"></ng-container>
        <div class="tw-flex tw-flex-none tw-min-w-[2.5rem] tw-items-center tw-justify-end tw-gap-1">
          @if (showEditButton) {
            <ng-container *ngTemplateOutlet="editButton"></ng-container>
          }
          <ng-container *ngTemplateOutlet="closeButton"></ng-container>
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="titleSection"></ng-container>
      <div class="tw-flex tw-gap-2 tw-flex-none">
        <ng-container *ngTemplateOutlet="backButton"></ng-container>
        <ng-container *ngTemplateOutlet="closeButton"></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #titleSection>
  <div
    class="tw-flex tw-items-center tw-flex-1 tw-min-w-0"
    [ngClass]="showMobileLayout ? 'tw-flex-col tw-px-3 tw-text-center' : ''"
  >
    <span
      class="tw-font-medium tw-text-color-text-default tw-min-w-0"
      [ngClass]="[
        titleClass || 'tw-text-xl xs:tw-text-lg',
        showMobileLayout ? 'tw-w-full' : 'tw-flex-1',
        showMobileLayout && subtitle ? 'tw-truncate' : 'tw-line-clamp-3',
      ]"
      [title]="title"
    >
      {{ title }}
    </span>
    @if (showMobileLayout && subtitle) {
      <span class="tw-text-sm tw-font-normal tw-text-neutral-500 tw-truncate">{{ subtitle }}</span>
    }
    @if (enableTooltip) {
      <div title="help" (click)="tooltip.show($event)">
        <tooltip-icon
          [isClicked]="tooltip.isClicked"
          [size]="4"
          id="help-info-button-modal"
        ></tooltip-icon>
      </div>
    }
  </div>
</ng-template>

<ng-template #backButton>
  @if (showBackButton) {
    <button (click)="handleBackClick()" [class]="backButtonClass" data-testid="back-button">
      <icon [name]="'left-arrow'" [size]="7"></icon>
    </button>
  }
</ng-template>

<ng-template #editButton>
  <button
    type="button"
    class="btn-icon tw-text-primary"
    aria-label="Edit"
    (click)="onEditClicked.emit()"
  >
    <icon [name]="'add-entry'" [size]="5"></icon>
  </button>
</ng-template>

<ng-template #closeButton>
  @if (showCloseButton) {
    <close-button
      [buttonClass]="
        plainCloseButton ? 'tw-bg-transparent tw-border-0 tw-shadow-none tw-p-0' : 'btn-icon'
      "
      [type]="'plain'"
      [isMatDialog]="isMatDialog"
      [customizedCloseIcon]="customizedCloseIcon()"
      (closeClickedEvent)="handleClose()"
    >
    </close-button>
  }
</ng-template>
